// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"1387c000","458":"ba15295b","631":"2e3f99f9","774":"de7bcc12","787":"f437b5fb","820":"cca94c33","858":"7daf3b07","910":"5b8bdf1c"}[chunkId] + ".chunk.js";
};